import type { Audiencia, Plazo } from '../types'
import { fechaRel } from '../utils/fechas'

export const PLAZOS: Plazo[] = [
  {
    id: 'pl-01',
    expedienteId: 'ex-01',
    concepto: 'Coadyuvancia: aportar dictamen contable a la carpeta',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(-1),
    responsableId: 'ab-01',
    cumplido: false,
  },
  {
    id: 'pl-02',
    expedienteId: 'ex-05',
    concepto: 'Ampliación de embargo sobre bien inmueble',
    tipo: 'Presentación',
    fechaLimite: fechaRel(1),
    responsableId: 'ab-04',
    cumplido: false,
  },
  {
    id: 'pl-03',
    expedienteId: 'ex-02',
    concepto: 'Ofrecimiento de pruebas (10 días hábiles)',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(2),
    responsableId: 'ab-02',
    cumplido: false,
  },
  {
    id: 'pl-04',
    expedienteId: 'ex-13',
    concepto: 'Objeción de documentos exhibidos por la contraparte',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(3),
    responsableId: 'ab-07',
    cumplido: false,
  },
  {
    id: 'pl-05',
    expedienteId: 'ex-06',
    concepto: 'Alegatos previos al cierre de instrucción',
    tipo: 'Presentación',
    fechaLimite: fechaRel(5),
    responsableId: 'ab-03',
    cumplido: false,
  },
  {
    id: 'pl-06',
    expedienteId: 'ex-11',
    concepto: 'Solicitud de prórroga de investigación complementaria',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(6),
    responsableId: 'ab-06',
    cumplido: false,
  },
  {
    id: 'pl-07',
    expedienteId: 'ex-10',
    concepto: 'Exhibir nóminas y recibos de los 12 actores',
    tipo: 'Presentación',
    fechaLimite: fechaRel(7),
    responsableId: 'ab-05',
    cumplido: false,
  },
  {
    id: 'pl-08',
    expedienteId: 'ex-14',
    concepto: 'Contestación a excepciones del demandado',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(9),
    responsableId: 'ab-08',
    cumplido: false,
  },
  {
    id: 'pl-09',
    expedienteId: 'ex-04',
    concepto: 'Desahogo de vista del informe justificado',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(10),
    responsableId: 'ab-01',
    cumplido: false,
  },
  {
    id: 'pl-10',
    expedienteId: 'ex-09',
    concepto: 'Presentar estudio psicológico de convivencias',
    tipo: 'Presentación',
    fechaLimite: fechaRel(13),
    responsableId: 'ab-05',
    cumplido: false,
  },
  {
    id: 'pl-11',
    expedienteId: 'ex-08',
    concepto: 'Ampliación de demanda de amparo',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(15),
    responsableId: 'ab-03',
    cumplido: false,
  },
  {
    id: 'pl-12',
    expedienteId: 'ex-16',
    concepto: 'Inventario y avalúo del inmueble en copropiedad',
    tipo: 'Trámite interno',
    fechaLimite: fechaRel(18),
    responsableId: 'ab-07',
    cumplido: false,
  },
  {
    id: 'pl-13',
    expedienteId: 'ex-15',
    concepto: 'Integrar expediente administrativo certificado',
    tipo: 'Trámite interno',
    fechaLimite: fechaRel(22),
    responsableId: 'ab-08',
    cumplido: false,
  },
  {
    id: 'pl-14',
    expedienteId: 'ex-03',
    concepto: 'Ratificación de convenio ante el Centro de Conciliación',
    tipo: 'Presentación',
    fechaLimite: fechaRel(26),
    responsableId: 'ab-09',
    cumplido: false,
  },
  {
    id: 'pl-15',
    expedienteId: 'ex-01',
    concepto: 'Prescripción de la acción penal por fraude',
    tipo: 'Prescripción',
    fechaLimite: fechaRel(240),
    responsableId: 'ab-01',
    cumplido: false,
  },
  {
    id: 'pl-16',
    expedienteId: 'ex-02',
    concepto: 'Contestación de demanda reconvencional',
    tipo: 'Término judicial',
    fechaLimite: fechaRel(-18),
    responsableId: 'ab-02',
    cumplido: true,
  },
  {
    id: 'pl-17',
    expedienteId: 'ex-05',
    concepto: 'Exhibición de títulos de crédito originales',
    tipo: 'Presentación',
    fechaLimite: fechaRel(-34),
    responsableId: 'ab-04',
    cumplido: true,
  },
]

export const AUDIENCIAS: Audiencia[] = [
  {
    id: 'au-01',
    expedienteId: 'ex-01',
    tipo: 'Audiencia',
    titulo: 'Audiencia inicial (continuación)',
    fecha: fechaRel(0),
    hora: '09:30',
    lugar: 'Sala 2, Ciudad Judicial Veracruz',
    autoridad: 'Juzgado de Control, Veracruz',
    abogadoId: 'ab-01',
    sucursalId: 'ver',
  },
  {
    id: 'au-02',
    expedienteId: 'ex-05',
    tipo: 'Cita',
    titulo: 'Reunión con cliente: estrategia de embargo',
    fecha: fechaRel(0),
    hora: '16:00',
    lugar: 'Oficina CDMX, sala de juntas 6A',
    autoridad: 'Interna',
    abogadoId: 'ab-04',
    sucursalId: 'cmx',
  },
  {
    id: 'au-03',
    expedienteId: 'ex-02',
    tipo: 'Audiencia',
    titulo: 'Audiencia de desahogo de pruebas',
    fecha: fechaRel(1),
    hora: '11:00',
    lugar: 'Juzgado 1° Civil, planta baja',
    autoridad: 'Juzgado 1° Civil de Primera Instancia, Veracruz',
    abogadoId: 'ab-02',
    sucursalId: 'ver',
  },
  {
    id: 'au-04',
    expedienteId: 'ex-10',
    tipo: 'Audiencia',
    titulo: 'Audiencia preliminar laboral',
    fecha: fechaRel(2),
    hora: '10:15',
    lugar: 'Centro de Conciliación, Guadalajara',
    autoridad: 'Centro de Conciliación Laboral de Jalisco',
    abogadoId: 'ab-05',
    sucursalId: 'gdl',
  },
  {
    id: 'au-05',
    expedienteId: 'ex-13',
    tipo: 'Audiencia',
    titulo: 'Audiencia de alegatos',
    fecha: fechaRel(3),
    hora: '09:00',
    lugar: 'Sala Civil, TSJ Nuevo León',
    autoridad: 'Tribunal Superior de Justicia de N.L., Sala Civil',
    abogadoId: 'ab-07',
    sucursalId: 'mty',
  },
  {
    id: 'au-06',
    expedienteId: 'ex-09',
    tipo: 'Cita',
    titulo: 'Entrevista con trabajadora social',
    fecha: fechaRel(3),
    hora: '13:30',
    lugar: 'Juzgado 5° Familiar, cubículo 3',
    autoridad: 'Juzgado 5° Familiar de Guadalajara',
    abogadoId: 'ab-05',
    sucursalId: 'gdl',
  },
  {
    id: 'au-07',
    expedienteId: 'ex-11',
    tipo: 'Audiencia',
    titulo: 'Audiencia de revisión de medida cautelar',
    fecha: fechaRel(4),
    hora: '12:00',
    lugar: 'Sala 4, Juzgado de Control',
    autoridad: 'Juzgado de Control del Sistema Penal Acusatorio',
    abogadoId: 'ab-06',
    sucursalId: 'gdl',
  },
  {
    id: 'au-08',
    expedienteId: 'ex-06',
    tipo: 'Audiencia',
    titulo: 'Cierre de instrucción',
    fecha: fechaRel(5),
    hora: '10:00',
    lugar: 'Sala Metropolitana, TFJA',
    autoridad: 'Tribunal Federal de Justicia Administrativa',
    abogadoId: 'ab-03',
    sucursalId: 'cmx',
  },
  {
    id: 'au-09',
    expedienteId: 'ex-04',
    tipo: 'Audiencia',
    titulo: 'Audiencia constitucional',
    fecha: fechaRel(8),
    hora: '09:45',
    lugar: 'Juzgado 3° de Distrito, Veracruz',
    autoridad: 'Juzgado 3° de Distrito en Veracruz',
    abogadoId: 'ab-01',
    sucursalId: 'ver',
  },
  {
    id: 'au-10',
    expedienteId: 'ex-14',
    tipo: 'Cita',
    titulo: 'Firma de convenio con deudor',
    fecha: fechaRel(9),
    hora: '15:00',
    lugar: 'Notaría 108, Monterrey',
    autoridad: 'Externa',
    abogadoId: 'ab-08',
    sucursalId: 'mty',
  },
  {
    id: 'au-11',
    expedienteId: 'ex-16',
    tipo: 'Audiencia',
    titulo: 'Junta de herederos',
    fecha: fechaRel(12),
    hora: '11:30',
    lugar: 'Juzgado Familiar, Monterrey',
    autoridad: 'Juzgado Familiar de Monterrey',
    abogadoId: 'ab-07',
    sucursalId: 'mty',
  },
  {
    id: 'au-12',
    expedienteId: 'ex-03',
    tipo: 'Cita',
    titulo: 'Audiencia de conciliación prejudicial',
    fecha: fechaRel(14),
    hora: '10:30',
    lugar: 'Centro de Conciliación, Veracruz',
    autoridad: 'Centro de Conciliación Laboral',
    abogadoId: 'ab-09',
    sucursalId: 'ver',
  },
  {
    id: 'au-13',
    expedienteId: 'ex-15',
    tipo: 'Cita',
    titulo: 'Mesa de trabajo con la autoridad municipal',
    fecha: fechaRel(17),
    hora: '09:00',
    lugar: 'Palacio Municipal, Santa Catarina',
    autoridad: 'Municipio de Santa Catarina',
    abogadoId: 'ab-08',
    sucursalId: 'mty',
  },
  {
    id: 'au-14',
    expedienteId: 'ex-01',
    tipo: 'Audiencia',
    titulo: 'Audiencia inicial',
    fecha: fechaRel(-22),
    hora: '09:00',
    lugar: 'Sala 2, Ciudad Judicial Veracruz',
    autoridad: 'Juzgado de Control, Veracruz',
    abogadoId: 'ab-01',
    sucursalId: 'ver',
  },
  {
    id: 'au-15',
    expedienteId: 'ex-02',
    tipo: 'Audiencia',
    titulo: 'Audiencia previa y de conciliación',
    fecha: fechaRel(-40),
    hora: '10:00',
    lugar: 'Juzgado 1° Civil, planta baja',
    autoridad: 'Juzgado 1° Civil de Primera Instancia, Veracruz',
    abogadoId: 'ab-02',
    sucursalId: 'ver',
  },
  {
    id: 'au-16',
    expedienteId: 'ex-13',
    tipo: 'Audiencia',
    titulo: 'Desahogo de prueba pericial',
    fecha: fechaRel(-15),
    hora: '12:30',
    lugar: 'Sala Civil, TSJ Nuevo León',
    autoridad: 'Tribunal Superior de Justicia de N.L., Sala Civil',
    abogadoId: 'ab-07',
    sucursalId: 'mty',
  },
]
